import { render } from "./PeriodsContent.vue?vue&type=template&id=72d1a59b&ts=true"
import script from "./PeriodsContent.vue?vue&type=script&lang=ts"
export * from "./PeriodsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__